export default "__VITE_ASSET__CFxQOBtr__"